import { Spacing } from '@persona-id/design-tokens';
import * as CSS from 'csstype';
import { ComponentPropsWithoutRef } from 'react';
import styled, { css } from 'styled-components';

export interface StackProps {
  /**
   * Spacing between items. Defaults to Spacing[3].
   *
   * @defaultValue Spacing[3]
   */
  spacing?: Spacing;

  /**
   * Direction of Stack. Defaults to vertical.
   *
   * @defaultValue 'vertical'
   */
  direction?: 'vertical' | 'horizontal';

  /**
   * Passed through as `align-items`
   */
  align?: CSS.Property.AlignItems;

  /**
   * Passed through as `justify-content`
   */
  justify?: CSS.Property.JustifyContent;

  /**
   * Passed through as `flex-wrap`
   */
  wrap?: CSS.Property.FlexWrap;

  /**
   * Give each item an equal width/height.
   */
  equal?: boolean;
}

const Stack = styled('div')<StackProps>`
  display: flex;
  flex-direction: ${({ direction }) => (direction === 'horizontal' ? 'row' : 'column')};
  gap: ${({ spacing }) => spacing || Spacing[2]};

  ${({ align }) =>
    align &&
    css`
      align-items: ${align};
    `}

  ${({ justify }) =>
    justify &&
    css`
      justify-content: ${justify};
    `}

  ${({ wrap }) =>
    wrap &&
    css`
      flex-wrap: ${wrap};
    `}

  ${({ equal }) =>
    equal &&
    css`
      > * {
        flex-grow: 1;
        flex-basis: 0;
      }
    `}
`;

export default Stack;

export type HStackProps = ComponentPropsWithoutRef<'div'> & StackProps;

export const HStack = (props: HStackProps) => <Stack {...props} direction='horizontal' />;
